import React, { useContext, useEffect } from 'react';

import useApi from 'common/useApi';
import UiContext from 'common/UiContext/UiContext';

import RewardsSummary from 'components/RewardsSummary';
import PoolStatisticsSummary from 'components/PoolStatisticsSummary';
import DashboardWorkerSummary from 'components/DashboardWorkerSummary';
import PoolInformation from 'components/PoolInformation';
import RecentHashrate from 'components/RecentHashrate';
import PoolHashrateHistory from 'components/PoolHashrateHistory';
import EstimatedEarnings from 'components/EstimatedEarnings';
import WorkerAlertBanner from 'components/WorkerAlertBanner';

const Dashboard = () => {
  const { addToast } = useContext(UiContext);
  const { data, isError, isLoading } = useApi('get', '/api/dashboard/totals');

  useEffect(() => {
    if(isError) {
        addToast!('Error loading data. Please, retry');
    }
  }, [isError]);



  return (
    <>
      <WorkerAlertBanner count={data?.workers_low} />
      <DashboardWorkerSummary data={data} isLoading={isLoading} />
      <RecentHashrate />
      <article className='row-neuboxes'>
        <RewardsSummary withTitle={true} boxed={true} data={data} isLoading={isLoading} />
        <EstimatedEarnings />
      </article>
      <article className='row-neuboxes'>
        <PoolStatisticsSummary data={data} isLoading={isLoading} />
      </article>
      <PoolHashrateHistory />
      <PoolInformation data={data} isLoading={isLoading} />
    </>
  );
};

export default Dashboard;
